import * as styles from "./IntroBreed.module.scss";

import React, { useEffect } from "react";
import HeroImage from "../../../components/HeroImage/HeroImage";
import CurvedBorderShallow from "../../../components/borders/CurvedBorderShallow";
import {
	Age,
	Info,
	Measurements,
	Shedding,
} from "../../../components/common/Icons";
import { useDogSearchApi } from "../../../context";
import { Colours } from "../../../utils/colours";

export interface IntroBreedProps {
	title: string;
	intro: string;
	imgSrc: string;
	imgAlt: string;
	breedSize: string;
	breedShedding: string;
	breedLifeExpec: string;
	borderColour?: string;
}

export const IntroBreed: React.FC<IntroBreedProps> = ({
	title,
	intro,
	imgSrc,
	imgAlt,
	breedSize,
	breedShedding,
	breedLifeExpec,
	borderColour = Colours.WHITE,
}) => {
	const { useDogSearchQuery, onChangeFilterView } = useDogSearchApi();

	// biome-ignore lint/correctness/useExhaustiveDependencies: We only want this to run once on page load
	useEffect(() => {
		useDogSearchQuery();
	}, []);

	return (
		<section className={styles.breedherocontainer}>
			<div className={styles.topsectionouter}>
				<article className={styles.detailscontainer}>
					<header className={styles.textcontainer}>
						<h1>{title}</h1>
						{!!intro && <p>{intro}</p>}
					</header>
					<dl className={styles.keydetails}>
						<div className={styles.detail}>
							<dt className={styles.icon}>
								<Age height={"30px"} width={"30px"} />
							</dt>
							<dd className={styles.text}>
								<span className={styles.optiontitle}>Life Expectancy</span>
								<span className={styles.optionvalue}>{breedLifeExpec}</span>
							</dd>
						</div>
						<div className={styles.detail}>
							<dt className={styles.icon}>
								<Shedding height={"30px"} width={"30px"} />
							</dt>
							<dd className={styles.text}>
								<span className={styles.optiontitle}>Shedding</span>
								<span className={styles.optionvalue}>{breedShedding}</span>
							</dd>
						</div>
						<div className={styles.detail}>
							<dt className={styles.icon}>
								<Measurements height={"30px"} width={"30px"} />
							</dt>
							<dd className={styles.text}>
								<span className={styles.optiontitle}>Size</span>
								<span className={styles.optionvalue}>{breedSize}</span>
							</dd>
							<div className={styles.sizeguide}>
								<button
									type="button"
									className={styles.sizeguidecontent}
									onClick={() => onChangeFilterView("SizeGuide")}
									onKeyDown={(e) =>
										e.key === "Enter" && onChangeFilterView("SizeGuide")
									}
								>
									Size Guide
									<Info />
								</button>
							</div>
						</div>
					</dl>
				</article>
				<aside className={styles.imagecontainer}>
					<div className={styles.imagewrapper}>
						<HeroImage src={imgSrc} alt={imgAlt} />
					</div>
				</aside>
			</div>
			<footer className={styles.bordersection}>
				<CurvedBorderShallow
					className={styles.border}
					fill={borderColour}
					rotation={0}
				/>
			</footer>
		</section>
	);
};

export default IntroBreed;
